<template>
  <el-dialog
    :title="form.id ? '编辑班级' : '新建班级'"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
    :before-close="handleClose"
  >
    <el-form :model="form" :rules="rule" ref="formRef">
      <el-form-item
        label="培训班名称"
        :label-width="formLabelWidth"
        prop="name"
      >
        <el-input
          v-model="form.name"
          autocomplete="off"
          placeholder="请输入培训班名称"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="培训班分类"
        :label-width="formLabelWidth"
        prop="faceClassId"
      >
         <el-select
            :style="{ width:'100%' }"
            v-model="form.faceClassId"
            :placeholder="'请选择'"
          >
            <el-option
              v-for="option in selectData"
              :key="option.value"
              :label="option.name"
              :value="option.id"
              :disabled="option.status == 2"
            ></el-option>
          </el-select>
      </el-form-item>

      <el-form-item label="培训对象" :label-width="formLabelWidth">
        <el-input
          v-model="form.trainObject"
          autocomplete="off"
          placeholder="请输入培训对象"
          maxLength='200'
        ></el-input>
      </el-form-item>

      <el-form-item label="主办方" :label-width="formLabelWidth" prop="sponsor">
        <el-input
          v-model="form.sponsor"
          autocomplete="off"
          placeholder="请输入主办方"
        ></el-input>
      </el-form-item>

      <el-form-item label="承办方" :label-width="formLabelWidth">
        <el-input
          v-model="form.contractor"
          autocomplete="off"
          placeholder="请输入承办方"
        ></el-input>
      </el-form-item>
      <el-form-item label="证书颁发单位" :label-width="formLabelWidth">
        <el-select style="width: 400px" v-model="form.issuingAuthority" placeholder="请选择证书颁发单位">
          <el-option label="国家广播电视总局广播影视人才交流中心" value="国家广播电视总局广播影视人才交流中心"></el-option>
          <el-option label="北京新广汇贤人力资源管理有限责任公司" value="北京新广汇贤人力资源管理有限责任公司"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="简介" :label-width="formLabelWidth">
        <el-input
          type='textarea'
          v-model="form.introduction"
          autocomplete="off"
          maxLength='1000'
          placeholder="请输入简介"
        ></el-input>
      </el-form-item>

      <el-form-item label="图片" :label-width="formLabelWidth">
        <Upload :list='[]' @childByValue="getPic" :text="'，图片尺寸为220*120px'"></Upload>
        <img
            style='max-width:200px'
            class="pic"
            v-if="form.pictureUrl"
            :src="form.pictureUrl">
      </el-form-item>

      <el-form-item label="地点" :label-width="formLabelWidth" prop="address">
        <el-input
          v-model="form.address"
          autocomplete="off"
          maxlength=10
          placeholder="请输入地点"
        ></el-input>
      </el-form-item>

      <el-form-item label="学时" :label-width="formLabelWidth" prop="period">
        <el-input
          oninput="this.value = this.value.replace(/[^0-9]/g, '');"
          v-model="form.period"
          autocomplete="off"
          maxLength='200'
          placeholder="请输入学时"
        ></el-input>
      </el-form-item>
      <el-form-item label="报名" :label-width="formLabelWidth" prop="signStartTime">
        <el-date-picker
            v-model="form.signStartTime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item label="报到" :label-width="formLabelWidth" prop="reportStartTime">
        <el-date-picker
            v-model="form.reportStartTime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item label="开班" :label-width="formLabelWidth" prop="openStartTime">
        <el-date-picker
            v-model="form.openStartTime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item label="报名咨询电话" :label-width="formLabelWidth">
        <el-input
          v-model="form.consultPhone"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="人数限制" :label-width="formLabelWidth">
        <el-input
          v-model="form.title"
          autocomplete="off"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="班主任" :label-width="formLabelWidth" class="w50">
        <el-input
          v-model="form.teacherName"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话" :label-width="formLabelWidth" class="w50">
        <el-input
          v-model="form.teacherPhone"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="课程数量" :label-width="formLabelWidth" class="w50">
        <el-input
          v-model="form.courseNumber"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="实训数量" :label-width="formLabelWidth" class="w50">
        <el-input
          v-model="form.trainNumber"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="结业证书起始编号" :label-width="formLabelWidth" class="w50">
        <el-input
          v-model="form.graduationNumber"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="合格证书编号" :label-width="formLabelWidth" class="w50">
        <el-input
          v-model="form.qualityNumber"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="当前结业证书数量" v-if="form.id" :label-width="formLabelWidth" class="w50">
        <el-input
          oninput="this.value = this.value.replace(/[^0-9]/g, '');"
          readonly
          v-model="form.graduationSum"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="当前培训班人数" v-if="form.id" :label-width="formLabelWidth" class="w50">
        <el-input
          readonly
          oninput="this.value = this.value.replace(/[^0-9]/g, '');"
          v-model="form.trainSum"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Upload from '@/components/uploadCopy/index'
import { addClassInfo,updateClassInfo,getClassInfoSelectList } from '@/api/api'

export default {
  components: {
    Upload
  },
  props: {
    editParams: {
      type: Object,
      default: function(){
        return {}
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: "130px",
      form: {
        signStartTime:['2022-05-10 00:00:00','2022-05-11 00:00:00']
      },
      rule: {
        name: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
          {
            max: 200,
            message: "最长200个字符",
            trigger: "blur",
          },
        ],
        sponsor: [
          { required: true, message: "请输入主办方", trigger: "blur" },
          {
            max: 200,
            message: "最长200个字符",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "请输入地点", trigger: "blur" },
          {
            max: 200,
            message: "最长200个字符",
            trigger: "blur",
          },
        ],
        period: [
          { required: true, message: "请输入学时", trigger: "blur" },
        ],
        faceClassId: [
          // { required: true, message: "请选择培训班分类", trigger: "blur" },
        ],
        signStartTime: [
          { required: true, message: "请选择时间", trigger: "blur" },
        ],
        reportStartTime: [
          { required: true, message: "请选择时间", trigger: "blur" },
        ],
        openStartTime: [
          { required: true, message: "请选择时间", trigger: "blur" },
        ],

      },
      selectData:{}
    };
  },
  mounted(){
    getClassInfoSelectList({
    }).then(res => {
      let { code, message , data } = res;
      if (code === 0) {
        console.log(123123,data)
        this.selectData = data;
        // this.$message.success('更新成功');
        // this.$emit('success');
        // this.handleClose()
        // this.form = {}
      } else {
        this.$message.error(message);
      }
    })
  },
  methods: {
    // 上传图片
    getPic(file) {
      console.log(file);
      this.form['pictureUrl'] = file.url;
      this.$forceUpdate()
    },
    setOpacity(flg) {
      this.dialogVisible = flg;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    sure(){
      // return
      // console.log(new Date(this.form.signStartTime.getTime())
      //   .toJSON()
      //   .split("T")
      //   .join(" ")
      //   .substr(0, 4))

      // return false;
      if( this.form.period ){
        this.form.period = String(this.form.period)
      }
      this.$refs.formRef.validate((valid) => {
        if (valid) {
            let formCopy = JSON.parse(JSON.stringify(this.form));
            const data = formCopy.signStartTime;
            const data1 = formCopy.reportStartTime;
            const data2 = formCopy.openStartTime;
            formCopy.signStartTime = data[0]
            formCopy.signEndTime = data[1]
            formCopy.reportStartTime = data1[0]
            formCopy.reportEndTime = data1[1]
            formCopy.openStartTime = data2[0]
            formCopy.openEndTime = data2[1]


            if( formCopy.id ){
              updateClassInfo(formCopy).then(res => {
                let { code, message } = res;
                if (code === 0) {
                  this.$message.success('成功');
                  this.$emit('success');
                  this.handleClose()
                  this.form = {}
                } else {
                  this.$message.error(message);
                }
              })
            }else{
              addClassInfo(formCopy).then(res => {
                let { code, message } = res;
                if (code === 0) {
                  this.$message.success('成功');
                  this.$emit('success');
                  this.handleClose()
                  this.form = {}
                } else {
                  this.$message.error(message);
                }
              })
            }
        }else{

          }
        })
    }
  },
   watch: {
    editParams: {
      immediate: true,
      handler(newValue, oldValue) {
        // this.dialogVisible = newValue ?? true
        if( newValue.signStartTime ){
          newValue.signStartTime=[newValue.signStartTime,newValue.signEndTime]
        }
        if( newValue.reportStartTime ){
          newValue.reportStartTime=[newValue.reportStartTime,newValue.reportEndTime]
        }
        if( newValue.openStartTime ){
          newValue.openStartTime=[newValue.openStartTime,newValue.openEndTime]
        }
        // if( newValue.faceClassId ){
        //   newValue.faceClassId = Number(newValue.faceClassId)
        // }
        this.form = newValue ? JSON.parse(JSON.stringify(newValue)) : {}
      },
    },
  },
};
</script>

<style lang="scss">
.w50{
  width: 50%;
  display: inline-block;
}
.el-dialog__body{
  // max-height: 50vh;
  overflow-y: auto;
}
</style>
